import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutYesChefJess from "./sections/AboutYesChefJess";
import OurExperiences from "./sections/OurExperiences";
import Gallery from "./sections/Gallery";
import UpcomingEventsClasses from "./sections/UpcomingEventsClasses";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import ContactBooking from "./sections/ContactBooking";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutYesChefJess />
      <OurExperiences />
      <Gallery />
      <UpcomingEventsClasses />
      <Testimonials />
      <FAQ />
      <ContactBooking />
      <Footer />
    </div>;
}